import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { IConfig } from 'src/app/models/config';
import { Flags } from 'src/app/models/flags';

@Injectable({
  providedIn: 'root'
})
export class FlagService {
  
  private flagsSubject = new BehaviorSubject<Flags | null>(null);
  public flags$: Observable<Flags | null> = this.flagsSubject.asObservable();
  appConfig:IConfig;
  constructor(private http: HttpClient, private appService: AppService) {}
  
  loadFeatureFlags(): Promise<void> {
    this.appConfig = this.appService.getGlobalConfig();
    const url = `${this.appConfig.oneTrustScriptFlagApiUrl}?_=${Date.now()}`;
    return this.http.get<Flags>(url)
      .pipe(tap(flags => this.flagsSubject.next(flags)))
      .toPromise()
      .then(() => {})
      .catch(error => {
        console.error(`Cookie Consent Server returned code: ${error.status}, error message is: ${error.message}`);
      });
  }

  get enableOneTrustScript(): boolean {
    return this.flagsSubject.value?.featureFlag.enableOneTrustScript === 'true';
  }

  get showCookiePreferenceLink(): boolean {
    return this.flagsSubject.value?.featureFlag.showCookiePreferenceLink === 'true';
  }
}
